// Kullanıcı kendi logosunu yükleyene kadar gösterilen varsayılanlar.
// Dosya adlarındaki büyük/küçük harf önemli: prod'da nginx bunları
// büyük/küçük harfe duyarlı bir dosya sisteminden servis ediyor.
export const MA360_REPORT_LOGO = "/BrandIcons/ma360ReportLogo.png";
export const THREAT_HUNTER_REPORT_LOGO = "/BrandIcons/thReportLogo.png";
